"use client";
import {
  TooltipContextProvider
} from "../__chunks/V3XGKTI7.js";
import "../__chunks/BEBUB5QN.js";
import "../__chunks/M6ZUVZPG.js";
import "../__chunks/32IPIQBR.js";
import "../__chunks/EQMNTDLB.js";
import "../__chunks/PTCNA5XT.js";
import {
  useTooltipStore
} from "../__chunks/VJLRJATI.js";
import "../__chunks/TWVD2KYP.js";
import "../__chunks/WB2VUSZO.js";
import "../__chunks/XRRE3XFB.js";
import "../__chunks/TUWQEMG5.js";
import "../__chunks/FQ77EHUR.js";
import "../__chunks/WX6L4ACS.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/tooltip/tooltip-provider.tsx
import { jsx } from "react/jsx-runtime";
function TooltipProvider(props = {}) {
  const store = useTooltipStore(props);
  return /* @__PURE__ */ jsx(TooltipContextProvider, { value: store, children: props.children });
}
export {
  TooltipProvider
};
